import { Divider } from "antd";

export const SettingTitle = ({ title }) => {
  return (
    <>
      <div style={{ fontSize: 24 }}>{title}</div>
      <Divider style={{ margin: "8px 0px" }} />
    </>
  );
};
